import React, { useState } from 'react';
import CloseIcon from '@material-ui/icons/Close';
import { SliderDots } from 'common/components/SliderDots';
import ImgBox from 'common/components/ImgBox';

import { Box, Typography, Grid, IconButton, Dialog, makeStyles } from '@material-ui/core';
import { withTranslation } from 'config/i18n';
import Carousel from 'react-multi-carousel';
import 'react-multi-carousel/lib/styles.css';
import ChevronLeftIcon from '@material-ui/icons/ChevronLeft';
import ChevronRightIcon from '@material-ui/icons/ChevronRight';

const useStyles = makeStyles((theme) => ({
  MICSDialog: {
    '&.MuiDialog-root': {
      position: 'absolute !important',
      zIndex: '1301 !important',
    },
    '& .MuiDialog-paper': {
      padding: theme.spacing(2),
      width: theme.spacing(31.875),
    },
    '& .MICSCloseBtn': {
      padding: 0,
    },
    '& .MISTitleAndPriceContiner': {
      display: 'flex',
      justifyContent: 'space-between',
    },
    '& .MICSEagleTitle': {
      fontWeight: '300',
    },
    '& .MICSPrice': {
      fontWeight: '700',
      fontSize: theme.spacing(2.25),
    },
    '& .MICSPriceHour': {
      fontWeight: '500',
      fontSize: theme.spacing(1.75),
    },
    '& .MICSDays': {
      fontWeight: '300',
      fontSize: theme.spacing(1.5),
    },
    '& .react-multi-carousel-track ': {
      marginBottom: 0,
      marginLeft: 'auto',
      marginRight: 'auto',
    },
    '.SDAArrow.SDALeftArrow': {
      left: theme.spacing(-4),
    },
    '& .react-multiple-carousel__arrow ': {
      bottom: theme.spacing(-1.25),
      backgroundColor: 'transparent',
      minWidth: 'unset',
      padding: 0,
      fontWeight: '700',
      '&:hover': {
        background: 'transparent',
      },
      '&:before': {
        color: theme.palette.secondary.dark,
      },
      '&.react-multiple-carousel__arrow--left': {
        left: theme.spacing(2),
      },
      '&.react-multiple-carousel__arrow--right': {
        right: theme.spacing(2),
      },
    },
    '& .react-multi-carousel-dot button': {
      backgroundColor: theme.palette.grey[100],
      borderColor: 'transparent',
    },
    '& .react-multi-carousel-dot--active button': {
      backgroundColor: theme.palette.grey[300],
      borderColor: 'transparent',
    },
    '&.IBimgbox': {
      [theme.breakpoints.down('md')]: {
        width: theme.spacing(3),
      },
    },
  },
}));

const ArrowLeft = (arrowLeftProps) => (
  <>
    <span {...arrowLeftProps} className="arrow arrowLeft">
      <ChevronLeftIcon />
    </span>
  </>
);

const ArrowRight = (arrowRightProps) => (
  <>
    <span {...arrowRightProps} className="arrow arrowRight">
      <ChevronRightIcon />
    </span>
  </>
);
const responsive = {
  desktop: {
    breakpoint: { max: 3000, min: 1024 },
    items: 1,
  },
  tablet: {
    breakpoint: { max: 1024, min: 464 },
    items: 1,
  },
  mobile: {
    breakpoint: { max: 464, min: 0 },
    items: 1,
  },
};

const MapInfoCardSection = (props) => {
  const { t, open, handleClose, containerId, handleBikeCardClick, rentalsItems = [] } = props;
  const [itemNum, setItemNum] = useState(1);

  const isOwner = () => rentalsItems[itemNum - 1].host?.type === 'owner';

  const logo = {
    src: isOwner() ? '/imgs/user_icon.png' : '/imgs/er_icon.svg',
    alt: 'logo',
  };
  const getRegion = (bike) =>
    `${bike.host?.geography?.name || bike.host.city_name}, ${
      bike.host?.region?.name || bike.host?.country?.name
    }`;

  const getItemCurrentSlide = (num) => {
    setItemNum(num);
  };

  const classes = useStyles();
  return (
    <Dialog
      open={open}
      onClose={handleClose}
      className={classes.MICSDialog}
      BackdropProps={{ style: { backgroundColor: 'transparent' } }}
      container={() => document.getElementById(containerId)}
      items={rentalsItems.length > 1}
      id="map-info-card"
    >
      <Grid container>
        <Grid item xs={2} lg={2}>
          <ImgBox image={logo} imgObjectFit="contain" imgWidth="24px" imgHeight="24px" />
        </Grid>
        <Grid item xs={9} lg={9}>
          <Typography variant="caption" component="p" className="MICSEagleTitle">
            {isOwner()
              ? `${t('fe_bike_card:rented_by')} ${rentalsItems[itemNum - 1].host?.name}`
              : t('fe_bike_card:er')}
          </Typography>
          <Typography variant="caption">
            {isOwner()
              ? !!rentalsItems[itemNum - 1] && getRegion(rentalsItems[itemNum - 1])
              : rentalsItems[itemNum - 1].host?.name}
          </Typography>
        </Grid>
        <Grid item xs={1} lg={1}>
          <IconButton onClick={handleClose} className="MICSCloseBtn" id="map-info-card-colse">
            <CloseIcon />
          </IconButton>
        </Grid>
      </Grid>
      <Box pt={2.5}>
        <Carousel
          swipeable={false}
          draggable={false}
          responsive={responsive}
          keyBoardControl
          customTransition="all 0.5s"
          customButtonGroup={
            rentalsItems.length > 1 && (
              <SliderDots
                slidesArray={rentalsItems}
                length={rentalsItems.length}
                getItemCurrentSlide={getItemCurrentSlide}
                responsiveStyle={{
                  desktop: {
                    breakpoint: { max: 3000, min: 1024 },
                    items: 5,
                  },
                  tablet: {
                    breakpoint: { max: 1024, min: 464 },
                    items: 5,
                  },
                  mobile: {
                    breakpoint: { max: 464, min: 0 },
                    items: 5,
                  },
                }}
              />
            )
          }
          renderButtonGroupOutside
          customLeftArrow={<ArrowLeft />}
          customRightArrow={<ArrowRight />}
          autoPlay={false}
          shouldResetAutoplay={false}
        >
          {rentalsItems.map((item) => (
            <Box
              className="CarouselItem"
              key={item.id}
              onClick={() => {
                handleBikeCardClick(item);
              }}
            >
              <ImgBox image={item.image} imgHeight="144px" imgObjectFit="contain" />
              <Box className="MISTitleAndPriceContiner">
                <Box>
                  <Typography variant="body2">{item.title}</Typography>
                  <Typography variant="body2">{item.subTitle}</Typography>
                </Box>
                <Box item xs={4} lg={4} textAlign="end">
                  <Box>
                    <Typography className="MICSPrice" component="span">
                      {item.price || item.hourly_price}
                    </Typography>
                    <Typography className="MICSDays" component="span">
                      /{item.price ? t('fe_bike_card:day') : t('fe_bike_card:hour')}
                    </Typography>
                  </Box>

                  {item.price && item.hourly_price && (
                    <>
                      <Typography className="MICSPriceHour" component="span">
                        {item.hourly_price}
                      </Typography>
                      <Typography className="MICSDays" component="span">
                        /{t('fe_bike_card:hour')}
                      </Typography>
                    </>
                  )}
                </Box>
              </Box>
            </Box>
          ))}
        </Carousel>
      </Box>
      {rentalsItems.length > 1 && (
        <Typography variant="body2" component="p" textAlign="center" pt={1}>
          {itemNum}/{rentalsItems.length}
        </Typography>
      )}
    </Dialog>
  );
};

export default withTranslation(['fe_bike_card'])(MapInfoCardSection);
